import PropTypes from 'prop-types'
import { Component, createRef } from 'react'

import { Button } from '../Button'
import { ErrorMessage } from '../ErrorMessage'
import { RequiredSpan } from '../RequiredSpan'

import './styles.scss'

export class RadioButtonGroup extends Component {
  constructor (props) {
    super(props)
    this.clearValues = this.clearValues.bind(this)
    this.handleChange = this.handleChange.bind(this)
    this.renderErrors = this.renderErrors.bind(this)
    this.input = createRef()
  }

  handleChange (value) {
    const { disabled, onChange } = this.props
    if (!disabled && onChange) {
      onChange(value)
    }
  }

  clearValues (event) {
    event.preventDefault()
    this.handleChange('')
  }

  renderErrors () {
    const { errors } = this.props
    return <ErrorMessage errors={errors} />
  }

  renderRequired () {
    const { required } = this.props
    if (!required) {
      return <div />
    }
    return <RequiredSpan />
  }

  renderButtons () {
    const { options, value, errors, disabled } = this.props

    const className = [ 'radio-container' ]

    if (errors && errors.length) {
      className.push('errors')
    }
    return options?.map((o, index) => (
      <div
        className={className.join(' ')}
        key={`RadioButton${index}`}
      >
        <input
          onClick={() => {
            this.handleChange(o.value)
          }}
          ref={this.input}
          className='nh-radio'
          type='radio'
          value={o.value}
          checked={o.value === value}
          readOnly
          disabled={disabled}
        />
        {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-noninteractive-element-interactions */}
        <label
          onClick={() => {
            this.handleChange(o.value)
          }}
        >
          <span className='radio'>
            {' '}
            {o.label}
            {' '}
          </span>
        </label>
      </div>
    ))
  }

  renderClear () {
    const { noClear, disabled } = this.props
    if (noClear) {
      return false
    }

    return (
      <Button
        grey
        label='Clear'
        disabled={disabled}
        onClick={this.clearValues}
      />
    )
  }

  render () {
    const { errors } = this.props
    return (
      <div>
        <div className='radio-section'>
          {this.renderButtons()}
          {this.renderClear()}
        </div>
        {this.renderRequired()}
        <ErrorMessage errors={errors} />
      </div>
    )
  }
}

RadioButtonGroup.propTypes = {
  options: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,

      value: PropTypes.any
    })
  ),
  noClear: PropTypes.bool,
  errors: PropTypes.arrayOf(PropTypes.string)
}
